<template>
  <div class="dod30">
    <div class="dod30_view" ref="dod30"></div>
  </div>
</template>

<script>
import { Particle } from '@/modules/dod/day30-pixijs-blur-particle'

export default {
  name: 'Day30',

  data: () => ({
    pixi: false
  }),

  methods: {
    init() {
      this.pixi = new Particle(this.$refs.dod30)
    }
  },

  beforeDestroy() {
    if (this.pixi) {
      this.pixi.destroy()
    }
  },

  mounted() {
    this.init()
  }
}
</script>

<style lang="scss">
.dod30 {
  @include FR_FULLSIZE;
  overflow: hidden;
}
.dod30_view {
  @include FR_FULLSIZE;
  user-select: none;
  pointer-events: none;
  > canvas {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
